import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { useState, useEffect } from "react";
import { Grid, Button, DataTable, Divider, DialogComercialTask, Paper, ListItem, DialogOpportunity, Create, Clear, AccountCircleIcon, makeStyles, Typography, SMPopover, Dialog, numeral, setLocale } from "../../../../";
var useStyles = makeStyles(function (theme) {
  var _leftMain;

  return {
    leftMain: (_leftMain = {}, _defineProperty(_leftMain, theme.breakpoints.up("md"), {
      boxShadow: "15px 0 15px -5px #333"
    }), _defineProperty(_leftMain, "padding", "24px"), _defineProperty(_leftMain, "height", "100%"), _defineProperty(_leftMain, "overflowY", "scroll"), _leftMain),
    headerLeftMain: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    },
    headerOpportunity: {
      display: "flex",
      "align-items": "center",
      justifyContent: "space-between"
    },
    dataOpportunity: {
      margin: "10px",
      display: "flex",
      "flex-direction": "column",
      "align-items": "left"
    },
    icon: {
      width: "80px",
      height: "auto"
    },
    contact: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      background: "#ededed45",
      borderRadius: "4px"
    },
    actionsOpportunity: {
      display: "flex",
      justifyContent: "flex-end",
      "max-width": "86%"
    },
    infoOpportunity: {
      margin: "10px",
      display: "flex",
      "flex-direction": "column",
      "align-items": "left"
    },
    divider: {
      margin: "20px 0",
      height: "4px"
    },
    mr30: {
      margin: "30px"
    },
    edit: {
      color: theme.palette.pending.main
    }
  };
});

var FranchiseOpportunitySingle = function FranchiseOpportunitySingle(_ref) {
  var translation = _ref.translation,
      opportunity = _ref.opportunity,
      editOpportunity = _ref.editOpportunity,
      deleteOpportunity = _ref.deleteOpportunity,
      createTask = _ref.createTask,
      deleteTask = _ref.deleteTask,
      tasks = _ref.tasks,
      editTask = _ref.editTask,
      taskColumns = _ref.taskColumns,
      title = _ref.title,
      options = _ref.options,
      locale = _ref.locale,
      currency = _ref.currency;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      openAddTask = _useState2[0],
      setAddTaskOpen = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      openViewTask = _useState4[0],
      setViewTaskOpen = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      openEditTask = _useState6[0],
      setEditTaskOpen = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      openDeleteTask = _useState8[0],
      setDeleteTaskOpen = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      openEditOpportunity = _useState10[0],
      setEditOpportunityOpen = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      openDeleteOpportunity = _useState12[0],
      setDeleteOpportunityOpen = _useState12[1];

  var _useState13 = useState({}),
      _useState14 = _slicedToArray(_useState13, 2),
      selectedTask = _useState14[0],
      setSelectedTask = _useState14[1];

  var classes = useStyles();
  useEffect(function () {
    locale && setLocale(locale);
  }, [locale]); // eslint-disable-next-line no-unused-expressions

  taskColumns ? taskColumns[7].options = {
    filter: false,
    sort: false,
    viewColumns: false,
    empty: true,
    label: false,
    customBodyRender: function customBodyRender(value, tableMeta, updateValue) {
      return /*#__PURE__*/React.createElement(SMPopover, {
        data: tableMeta.rowData,
        type: "tasks",
        labels: [{
          label: "View",
          name: "view",
          onItemClick: handleItemDatatablePopover
        }, {
          label: "Edit",
          name: "edit",
          onItemClick: handleItemDatatablePopover
        }, {
          label: "Delete",
          name: "delete",
          onItemClick: handleItemDatatablePopover
        }]
      });
    }
  } : null; // eslint-disable-next-line no-unused-expressions

  translation && !taskColumns ? translation.datatables ? translation.datatables.tasks ? translation.datatables.tasks.columns[7] ? translation.datatables.tasks.columns[7].options = {
    filter: false,
    sort: false,
    viewColumns: false,
    empty: true,
    label: false,
    customBodyRender: function customBodyRender(value, tableMeta, updateValue) {
      return /*#__PURE__*/React.createElement(SMPopover, {
        data: tableMeta.rowData,
        type: "tasks",
        labels: [{
          label: translation.popovers.tasks.view || "View",
          name: "view",
          onItemClick: handleItemDatatablePopover
        }, {
          label: translation.popovers.tasks.edit || "Edit",
          name: "edit",
          onItemClick: handleItemDatatablePopover
        }, {
          label: translation.popovers.tasks["delete"] || "Delete",
          name: "delete",
          onItemClick: handleItemDatatablePopover
        }]
      });
    }
  } : null : null : null : null;

  var handleDialogAddTask = function handleDialogAddTask() {
    setAddTaskOpen(!openAddTask);
  };

  var handleDialogViewTask = function handleDialogViewTask(id) {
    if (!openViewTask) {
      var task = tasks.find(function (task) {
        return task._id === id;
      });
      setSelectedTask(_objectSpread(_objectSpread({}, task), {}, {
        person_of_contact: task.contact._id
      }));
    } else {
      setSelectedTask({});
    }

    setViewTaskOpen(!openViewTask);
  };

  var handleDialogEditTask = function handleDialogEditTask(id) {
    if (!openEditTask) {
      var task = tasks.find(function (task) {
        return task._id === id;
      });
      setSelectedTask(_objectSpread(_objectSpread({}, task), {}, {
        person_of_contact: task.contact._id
      }));
    } else {
      setSelectedTask({});
    }

    setEditTaskOpen(!openEditTask);
  };

  var handleDialogDeleteTask = function handleDialogDeleteTask(id) {
    if (!openDeleteTask) {
      var task = tasks.find(function (task) {
        return task._id === id;
      });
      setSelectedTask(_objectSpread(_objectSpread({}, task), {}, {
        person_of_contact: task.contact._id
      }));
    } else {
      setSelectedTask({});
    }

    setDeleteTaskOpen(!openDeleteTask);
  };

  var handleDialogEditOpportunity = function handleDialogEditOpportunity() {
    setEditOpportunityOpen(!openEditOpportunity);
  };

  var handleDialogDeleteOpportunity = function handleDialogDeleteOpportunity() {
    setDeleteOpportunityOpen(!openDeleteOpportunity);
  }; // let currency = " €";
  // if (opportunity.currency) {
  //   switch (opportunity.currency) {
  //     case "euro":
  //       currency = " €";
  //       break;
  //     case "dollar":
  //       currency = " $";
  //       break;
  //     case "sol":
  //       currency = " S/.";
  //       break;
  //     default:
  //       currency = " €";
  //   }
  // }


  var handleItemDatatablePopover = function handleItemDatatablePopover(item, id) {
    // console.log("item Clicked", item);
    if (item === "view") {
      handleDialogViewTask(id);
    } else if (item === "edit") {
      handleDialogEditTask(id);
    } else if (item === "delete") {
      handleDialogDeleteTask(id);
    }
  };

  return /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(DialogOpportunity, {
    currency: currency,
    open: openEditOpportunity,
    onClose: handleDialogEditOpportunity,
    variant: "edit",
    editOpportunity: editOpportunity,
    opportunity: opportunity,
    translation: translation ? translation.dialogs.edit_opportunity : null
  }), /*#__PURE__*/React.createElement(DialogComercialTask, {
    open: openAddTask,
    variant: "add",
    translation: translation ? translation.dialogs.add_task : null,
    createTask: createTask,
    onClose: handleDialogAddTask,
    peopleOfContact: opportunity.contact ? opportunity.contact.people : []
  }), /*#__PURE__*/React.createElement(DialogComercialTask, {
    open: openViewTask,
    variant: "view",
    translation: translation ? translation.dialogs.add_task : null,
    onClose: handleDialogViewTask,
    task: selectedTask,
    peopleOfContact: opportunity.contact ? opportunity.contact.people : []
  }), /*#__PURE__*/React.createElement(DialogComercialTask, {
    open: openEditTask,
    variant: "edit",
    translation: translation ? translation.dialogs.add_task : null,
    onClose: handleDialogEditTask,
    editTask: editTask,
    task: selectedTask,
    peopleOfContact: opportunity.contact ? opportunity.contact.people : []
  }), /*#__PURE__*/React.createElement(Dialog, {
    open: openDeleteOpportunity,
    onClose: handleDialogDeleteOpportunity,
    id: "modal-confirm-delete-opportunity",
    title: translation ? translation.dialogs.delete_opportunity.title : null,
    text: translation ? translation.dialogs.delete_opportunity.info : null,
    submit: translation ? translation.dialogs.delete_opportunity.buttons["delete"] : null,
    buttonColorSubmit: "secondary",
    buttonVariantSubmit: "contained",
    onCancel: handleDialogDeleteOpportunity,
    cancel: translation ? translation.dialogs.delete_opportunity.buttons.cancel : null,
    buttonColorCancel: "secondary",
    buttonVariantCancel: "outlined",
    onSubmit: function onSubmit() {
      deleteOpportunity();
      handleDialogDeleteOpportunity();
    }
  }), /*#__PURE__*/React.createElement(Dialog, {
    open: openDeleteTask,
    onClose: handleDialogDeleteTask,
    id: "modal-confirm-delete-task",
    title: translation ? translation.dialogs.delete_task.title : null,
    text: translation ? translation.dialogs.delete_task.info : null,
    submit: translation ? translation.dialogs.delete_task.buttons["delete"] : null,
    buttonColorSubmit: "secondary",
    buttonVariantSubmit: "contained",
    onCancel: handleDialogDeleteTask,
    cancel: translation ? translation.dialogs.delete_task.buttons.cancel : null,
    buttonColorCancel: "secondary",
    buttonVariantCancel: "outlined",
    onSubmit: function onSubmit() {
      deleteTask(selectedTask);
      handleDialogDeleteTask();
    }
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 3,
    xs: 12,
    style: {
      paddingBottom: "10px",
      height: "100vh"
    }
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.leftMain
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.headerOpportunity
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.headerLeftMain
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, opportunity.name || "Sin nombre")), /*#__PURE__*/React.createElement("div", {
    className: classes.actionsOpportunity
  }, /*#__PURE__*/React.createElement(Button, {
    className: [classes.edit].join(" "),
    color: "default",
    variant: "text",
    "data-cy": "edit-opportunity",
    onClick: handleDialogEditOpportunity
  }, /*#__PURE__*/React.createElement(Create, null)), /*#__PURE__*/React.createElement(Button, {
    color: "secondary",
    variant: "text",
    "data-cy": "delete-opportunity",
    onClick: handleDialogDeleteOpportunity
  }, /*#__PURE__*/React.createElement(Clear, null)))), /*#__PURE__*/React.createElement(Divider, {
    className: classes.divider
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.dataOpportunity
  }, /*#__PURE__*/React.createElement(Typography, {
    color: "primary",
    variant: "h6"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1"
  }, translation ? translation.opportunity_info.opportunity_service_type : "Service type:"), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2"
  }, opportunity.serviceTypeLabel), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1"
  }, translation ? translation.opportunity_info.opportunity_estimated_value : "Budget"), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2"
  }, numeral(opportunity.budget).format("0,0[.]00 $")), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1"
  }, translation ? translation.opportunity_info.opportunity_status : "Status"), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2"
  }, opportunity.statusLabel)), /*#__PURE__*/React.createElement(Divider, {
    className: classes.divider
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.dataOpportunity
  }, /*#__PURE__*/React.createElement(Typography, {
    color: "primary",
    variant: "h6"
  }, translation ? translation.opportunity_info.opportunity_contact : null), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1"
  }, opportunity.contact ? opportunity.contact.name : null)), /*#__PURE__*/React.createElement(Divider, {
    className: classes.divider
  }), /*#__PURE__*/React.createElement(Typography, {
    color: "primary",
    variant: "h6",
    style: {
      margin: "10px"
    }
  }, translation ? translation.opportunity_info.opportunity_people_of_contact : null), /*#__PURE__*/React.createElement("div", {
    style: {
      overflowY: "scroll",
      maxHeight: "400px",
      margin: "10px"
    }
  }, opportunity.contact && opportunity.contact.people ? opportunity.contact.people.map(function (contact) {
    if (contact.type === "person") return /*#__PURE__*/React.createElement("div", {
      style: {
        padding: "16px"
      }
    }, /*#__PURE__*/React.createElement(ListItem, {
      className: classes.contact
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AccountCircleIcon, null)), /*#__PURE__*/React.createElement("div", {
      className: classes.infoOpportunity
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, contact.name), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption"
    }, contact.email), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption"
    }, contact.job))));else return null;
  }) : null))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 9,
    xs: 12
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justify: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.actionsOpportunity
  }, /*#__PURE__*/React.createElement(Button, {
    className: classes.mr30,
    color: "primary",
    variant: "outlined",
    onClick: handleDialogAddTask
  }, translation ? translation.buttons.add_task : "Add Task")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 11
  }, /*#__PURE__*/React.createElement(DataTable, {
    key: "_tasks",
    type: "tasks",
    data: tasks,
    translation: translation ? translation.datatables.tasks : null,
    columns: taskColumns,
    title: title,
    options: options
  })))));
};

export { FranchiseOpportunitySingle };